import React, { useEffect } from 'react';
import styles from './RobotModalV2.module.css';

import piperImg from '../../../static_files/fleet-robot-piper.png';
import tok2Img from '../../../static_files/fleet-robot-tok2.png';
import yamImg from '../../../static_files/fleet-robot-yam.png';

const ROBOT_IMAGES = {
    Piper: piperImg,
    TOK2: tok2Img,
    YAM: yamImg,
};

const IMAGE_CLASS = {
    Piper: styles.modalImgPiper,
    TOK2: styles.modalImgTok2,
    YAM: styles.modalImgYam,
};

const EST_EARNINGS_PER_WEEK = 1200;

function CheckIcon() {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="7" cy="7" r="6.5" stroke="rgba(214,191,150,0.4)" strokeWidth="0.8" />
            <path d="M4.2 7.2l1.9 1.9 3.7-4" stroke="#d6bf96" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default function RobotModalV2({ robot, onClose, onBuyNow }) {
    useEffect(() => {
        function handleKeyDown(e) {
            if (e.key === 'Escape') onClose();
        }
        document.addEventListener('keydown', handleKeyDown);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [onClose]);

    function handleOverlayClick(e) {
        if (e.target === e.currentTarget) onClose();
    }

    const imgSrc = ROBOT_IMAGES[robot.product_name];
    const imgClass = IMAGE_CLASS[robot.product_name] || '';
    const price = parseFloat(robot.fleet_purchase_price);
    const dof = `${robot.degree_of_freedom}-DOF`;
    const comm = robot.communication ? robot.communication.toUpperCase() : '—';

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={styles.modal} role="dialog" aria-modal="true">
                <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M1.5 1.5l9 9M10.5 1.5l-9 9" stroke="#181614" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>
                </button>

                <div className={styles.modalTitle}>{robot.product_name}</div>

                <div className={styles.modalBody}>
                    <div className={styles.modalImgPanel}>
                    {imgSrc && (
                        <img
                        src={imgSrc}
                        alt={robot.product_name}
                        className={`${styles.modalImg} ${imgClass}`}
                        />
                    )}
                    </div>

                    <div className={styles.modalInfo}>
                        <p className={styles.modalDesc}>{robot.machine_description}</p>

                        {robot.fleet_functionality_points?.length > 0 && (
                            <div className={styles.modalTags}>
                                {robot.fleet_functionality_points.map((tag) => (
                                <span key={tag} className={styles.modalTag}>{tag}</span>
                                ))}
                            </div>
                        )}

                        <div className={styles.modalDivider} />

                        <div className={styles.overviewTitle}>Product Overview</div>
                        <div className={styles.specGrid}>
                        <div>
                            <div className={styles.specLbl}>Manufacturer</div>
                            <div className={styles.specVal}>{robot.manufacture}</div>
                        </div>
                        <div>
                            <div className={styles.specLbl}>Category</div>
                            <div className={styles.specVal}>{robot.category}</div>
                        </div>
                        <div>
                            <div className={styles.specLbl}>Degrees of freedom</div>
                            <div className={styles.specVal}>{dof}</div>
                        </div>
                        <div>
                            <div className={styles.specLbl}>Communication</div>
                            <div className={styles.specVal}>{comm}</div>
                        </div>
                        </div>

                        <div className={`${styles.overviewTitle} ${styles.overviewTitleSpaced}`}>Highlights</div>
                        <ul className={styles.modalPoints}>
                            {robot.fleet_selling_points?.map((pt) => (
                                <li key={pt}>
                                <CheckIcon />
                                {pt}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <span className={styles.footerNote}>
                        Operators earn an estimated ${EST_EARNINGS_PER_WEEK.toLocaleString()}/week collecting with the {robot.product_name}.
                    </span>
                    <div className={styles.footerBuy}>
                        <div className={styles.footerPrice}>
                            <span className={styles.footerPriceVal}>
                                ${price.toLocaleString('en-US', { maximumFractionDigits: 0 })}
                            </span>
                            <span className={styles.footerPriceLbl}>Includes setup &amp; onboarding</span>
                        </div>
                        <button className={styles.reserveBtn} onClick={onBuyNow}>Buy now</button>
                    </div>
                </div>
            </div>
        </div>
  );
}
